module.exports = __webpack_public_path__ + "img/logo-habs.d26f43cd.svg";